// export const c_WEB_IP = "http://localhost:3000/";
// export const c_API_IP = "http://localhost:49894/";

// export const c_WEB_IP = "http://192.168.0.15:8089/";       // development server  
// export const c_API_IP = "http://192.168.0.15:49894/";

export const c_WEB_IP = "https://staff.cimation.com.my/";       // Live server  
export const c_API_IP = "https://staff.cimation.com.my:49894/";

